<template>
  <div class="sv prelative fs15 cpointer ofhidden" @click="goRoute(item.id)">
    <span class="pabsolute dt tc9">{{item.release_time}}</span>
    {{item.title}}
  </div>
</template>

<script>
export default {
  name: "item-right",
  data(){
    return {
      day:'01-01',
    }
  },
  props: [
    'item',
    'index',
    'goRoute',
  ],
  mounted() {

    // var date = new Date(this.item.release_time);
    // var dateTime = date.getTime() / 1000;
    // this.day = this.$request.date('m-d',dateTime);
  }
}
</script>

<style scoped>
  .eindex-wrap .newsdiv .sv:hover{font-weight: bold;color: #063674;}
  .eindex-wrap .newsdiv .sv:hover .dt{color: #063674;}
  .eindex-wrap .newsdiv .sv{margin-bottom: 25px;padding-right: 80px;height: 24px;}
  .eindex-wrap .newsdiv .dt{right: 0;font-size: 13px;}
  .eindex-wrap .newsdiv .more:hover{color: #063674;}
</style>



// WEBPACK FOOTER //
// src/components/aedu/index/item-right.vue